import {
    ToggleButton as UiToggleButton,
    Menu,
    MenuItem,
    styled
} from "@l2r-front/l2r-ui"

type ToggleButtonStyledProps = {
    buttonColor: string
}

export const ToggleButton = styled(UiToggleButton, { shouldForwardProp: (prop) => prop !== "buttonColor" })<ToggleButtonStyledProps>(({ theme, buttonColor }) => ({

    "&.MuiToggleButton-root": {

        ".MuiTypography-root": {
            textTransform: "none",
            color: "black",
            ...theme.typography["Desktop & Mobile/Body/Regular"],
        },

    },

    "&.Mui-selected": {
        background: theme.palette[buttonColor].main,
        borderTopLeftRadius: `${theme.spacing(3)}`,
        borderBottomLeftRadius: `${theme.spacing(3)}`,
        borderTopRightRadius: `${theme.spacing(3)}`,
        borderBottomRightRadius: `${theme.spacing(3)}`,

        "& + .Mui-selected": {
            borderTopLeftRadius: "0",
            borderBottomLeftRadius: "0",
        },

        "&:has(+ .Mui-selected)": {
            borderTopRightRadius: "0",
            borderBottomRightRadius: "0",
        },

        "&:not(:has(+ .Mui-selected))": {
            ":before": {
                display: "none",
            },
        },

        ".MuiTypography-root": {
            color: theme.palette[buttonColor].contrastText,
        },

        "svg": {
            fill: "white",
        },

        "&:hover": {
            backgroundColor: `${theme.palette[buttonColor].dark} !important`,
            color: theme.palette[buttonColor].dark,
            "@media (hover: none)": {
                backgroundColor: theme.palette[buttonColor].main,
            },
        },
    },
}))

export const ColorMenu = styled(Menu)(({ theme }) => ({

    ".MuiPaper-root": {
        marginTop: theme.spacing(1),
        borderRadius: 12,
        boxShadow: theme.shadows["LCS/Shadow-simple"],
        padding: 0,
    },

    "& .MuiList-root": {
        display: "flex",
        gap: theme.spacing(3),
        padding: theme.spacing(3),
    }

}))

type ColorItemStyledProps = {
    color: string
}

export const ColorItem = styled(MenuItem, { shouldForwardProp: (prop) => prop !== "color" })<ColorItemStyledProps>(({ theme, color }) => ({
    backgroundColor: theme.palette[color].main,
    borderRadius: "50%",
    width: 24,
    height: 24,
    minHeight: "auto",
    paddingLeft: 0,
    paddingRight: 0,

    "&:hover": {
        backgroundColor: theme.palette[color].dark,
        "@media (hover: none)": {
            backgroundColor: theme.palette[color].main,
        },
    },
}))